/* Below the fold, variant B. Loaded with defer by sections/wvh-below-b.liquid, so the whole page has been
   parsed by the time this runs: no part of it can look for something that does not exist yet. */
(function () {
  var root = document.querySelector('[data-wb]');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia('(max-width: 759px)');
  var EZ = 'cubic-bezier(.2,0,0,1)';
  var hasIO = 'IntersectionObserver' in window;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || root).querySelectorAll(s)); };

  /* Every film in this section plays at exactly 1x, always. Dan saw the install film run several times too
     fast after the page had been open a while, and a reload put it right. Nothing in this file touches the
     rate, but a browser extension or another script on the page can, so any change is put straight back. */
  $$('video').forEach(function (v) {
    v.defaultPlaybackRate = 1; v.playbackRate = 1;
    v.addEventListener('ratechange', function () { if (v.playbackRate !== 1) v.playbackRate = 1; });
  });

  /* ---------- reveal: one rise for everything ---------- */
  (function () {
    var items = $$('[data-r]');
    if (!hasIO || reduce.matches) { items.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    items.forEach(function (e) { io.observe(e); });
  })();

  /* ---------- graphics come alive on screen; numbers count in ---------- */
  (function () {
    var gfx = $$('[data-wb-gfx]');
    var nums = $$('[data-wb-count]');
    function paint(el, v) {
      var d = +el.getAttribute('data-wb-dec') || 0;
      el.textContent = d ? v.toFixed(d) : String(Math.round(v));
    }
    function count(el) {
      var to = parseFloat(el.getAttribute('data-wb-count'));
      if (isNaN(to)) return;
      var t0 = performance.now(), dur = 1100;
      (function tick(now) {
        var k = Math.min(1, (now - t0) / dur);
        paint(el, to * (1 - Math.pow(1 - k, 3)));
        if (k < 1) requestAnimationFrame(tick);
      })(t0);
    }
    if (!hasIO || reduce.matches) { gfx.forEach(function (g) { g.classList.add('in'); }); return; }
    nums.forEach(function (el) { paint(el, 0); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el);
        if (el.hasAttribute('data-wb-gfx')) el.classList.add('in');
        else count(el);
        if (el.hasAttribute('data-wb-gfx')) $$('[data-wb-count]', el).forEach(count);
      });
    }, { threshold: 0.45 });
    gfx.forEach(function (g) { io.observe(g); });
    nums.forEach(function (n) { if (!n.closest('[data-wb-gfx]')) io.observe(n); });
  })();

  /* ---------- 1. get the highlights ----------
     A continuous loop (Dan, 4 Nov: "it should be a continuous loop... from the start you should see a card
     going off the left side, which would be the last card"). The last two cards are copied in front of the
     first and the first two after the last. Autoplay and swipes travel onto a copy as normal; once the
     movement settles on a copy the track jumps, with no animation, to the real card it copies, which is
     pixel-for-pixel the same picture, so the row never runs out and never rewinds. The copies are inert
     and hidden from screen readers; dots and timing only ever count the six real cards. */
  (function () {
    var sec = $('[data-wb-hls]'); if (!sec) return;
    var track = $('[data-wb-hls-track]', sec);
    var cards = $$('[data-wb-hls-card]', sec);
    var dots = $$('[data-wb-hls-dot]', sec);
    var pp = $('[data-wb-hls-pp]', sec);
    var DUR = 6000, idx = 0, timer = 0, userPaused = false, visible = false, syncing = 0;
    sec.style.setProperty('--wb-dur', DUR + 'ms');
    if (reduce.matches) sec.classList.add('static');

    /* the copies: finished state, no ids or hooks of their own */
    var N = Math.min(2, cards.length - 1);
    function copy(c, of) {
      var k = c.cloneNode(true);
      k.removeAttribute('data-wb-hls-card'); k.setAttribute('data-wb-hls-of', of);
      k.setAttribute('aria-hidden', 'true'); k.setAttribute('inert', '');
      $$('[data-wb-gfx], [data-r]', k).forEach(function (g) { g.classList.add('in'); });
      $$('[data-wb-count]', k).forEach(function (n) {
        var d = +n.getAttribute('data-wb-dec') || 0, v = parseFloat(n.getAttribute('data-wb-count'));
        if (!isNaN(v)) n.textContent = d ? v.toFixed(d) : String(Math.round(v));
        n.removeAttribute('data-wb-count');
      });
      $$('[id]', k).forEach(function (e) { e.removeAttribute('id'); });
      $$('video', k).forEach(function (v) { v.removeAttribute('data-wb-hls-video'); v.removeAttribute('src'); v.preload = 'none'; });
      return k;
    }
    if (N > 0) {
      for (var i = 0; i < N; i++) {
        var from = cards.length - N + i;
        track.insertBefore(copy(cards[from], from), cards[0]);
        track.appendChild(copy(cards[i], i));
      }
    }
    var items = [].slice.call(track.children);

    function setDot(i) {
      dots.forEach(function (d, n) {
        d.classList.remove('on');
        if (n === i) { void d.offsetWidth; d.classList.add('on'); }
        d.setAttribute('aria-selected', String(n === i));
      });
    }
    /* the live card centred, its neighbours showing either side, on every screen */
    function left(el) { return el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2; }
    /* jump with no animation (used to step from a copy onto the real card) */
    function jump(el) {
      syncing = Date.now();
      track.style.scrollSnapType = 'none';
      track.scrollLeft = left(el);
      requestAnimationFrame(function () { track.style.scrollSnapType = ''; });
    }
    /* a one-second eased glide between cards (Apple's is about 1s; smooth scroll was about 0.3s) */
    var glideRaf = 0;
    function glide(to, done) {
      cancelAnimationFrame(glideRaf);
      var from = track.scrollLeft, t0 = performance.now(), D = 1000;
      track.style.scrollSnapType = 'none';
      (function f(now) {
        var k = Math.min(1, (now - t0) / D), e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
        track.scrollLeft = from + (to - from) * e;
        if (k < 1) glideRaf = requestAnimationFrame(f);
        else { track.style.scrollSnapType = ''; if (done) done(); }
      })(t0);
    }
    /* a card with a video plays it from the top each time it comes round, and stops on its last frame */
    function media() {
      cards.forEach(function (c, n) {
        var v = $('[data-wb-hls-video]', c); if (!v) return;
        if (n === idx && visible && !reduce.matches) {
          if (!v.getAttribute('src')) {
            var t = phone.matches;
            if (t && v.dataset.posterT) v.poster = v.dataset.posterT;
            v.src = t ? v.dataset.srcT : v.dataset.srcW; v.preload = 'auto';
          }
          try { v.currentTime = 0; } catch (e) {}
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }
    /* go to real card i. Stepping past either end travels onto the copy next to it, then lands on the real card. */
    function go(i, smooth) {
      var n = cards.length, wrapped = (i + n) % n, target = cards[wrapped];
      if (i === n && N > 0) target = items[N + n];             /* copy of the first card, after the last */
      if (i === -1 && N > 0) target = items[N - 1];            /* copy of the last card, before the first */
      idx = wrapped;
      syncing = Date.now() + 1000;
      if (smooth && !reduce.matches) glide(left(target), function () { if (target !== cards[idx]) jump(cards[idx]); });
      else jump(cards[idx]);
      setDot(idx); arm(); media();
    }
    function arm() {
      clearTimeout(timer);
      if (userPaused || !visible || reduce.matches) return;
      timer = setTimeout(function () { go(idx + 1, true); }, DUR);
    }
    function setPaused(p) {
      userPaused = p; sec.classList.toggle('paused', p);
      pp.setAttribute('aria-label', p ? 'Play the highlights' : 'Pause the highlights');
      if (!p) setDot(idx);
      arm();
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n, true); }); });
    pp.addEventListener('click', function () {
      setPaused(!(userPaused || reduce.matches)); if (reduce.matches) { sec.classList.remove('static'); go(idx + 1, true); }
    });
    /* a swipe is the shopper taking over: it pauses autoplay where they land (Apple) */
    var touched = false;
    ['touchstart', 'pointerdown'].forEach(function (ev) { track.addEventListener(ev, function () { touched = true; }, { passive: true }); });
    track.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) touched = true; }, { passive: true });
    /* a swipe is just a scroll: follow it; if it settles on a copy, step onto the real card */
    var st = 0;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        if (Date.now() - syncing < 900) return;
        var best = items[0], bd = Infinity, x = track.scrollLeft;
        items.forEach(function (c) { var dd = Math.abs(left(c) - x); if (dd < bd) { bd = dd; best = c; } });
        var real = best.hasAttribute('data-wb-hls-of') ? +best.getAttribute('data-wb-hls-of') : cards.indexOf(best);
        if (best !== cards[real]) jump(cards[real]);
        if (touched) { touched = false; if (real !== idx) { idx = real; setDot(idx); media(); } setPaused(true); return; }
        if (real !== idx) { idx = real; setDot(idx); arm(); media(); }
      }, 140);
    }, { passive: true });
    /* start on the first real card, with the last card's copy peeking in on the left; hold it there on resize */
    jump(cards[0]);
    var rz = 0;
    window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { jump(cards[idx]); }, 150); });
    if (hasIO) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        sec.classList.toggle('paused', userPaused || !visible);
        if (visible && !userPaused) setDot(idx);
        arm(); media();
      }, { threshold: 0.35 }).observe(track);
    }
    setDot(0);
  })();

  /* ---------- 2. take a closer look ----------
     The pill-to-card morph is a FLIP on the item's own box: measure it as a pill, switch it to a card,
     measure again, and animate between the two sizes. The siblings below move with it frame by frame,
     because a height animation is real layout, which is the effect on Apple's page. */
  (function () {
    var sec = $('[data-wb-cl]'); if (!sec) return;
    var items = $$('[data-wb-cl-item]', sec);
    var layers = $$('[data-wb-cl-layer]', sec);
    var readout = $('[data-wb-cl-readout]', sec);
    var cur = 0;
    function layer(i) { layers.forEach(function (l) { l.classList.toggle('on', +l.getAttribute('data-wb-cl-layer') === i); }); }
    function morph(item, toOpen) {
      var card = $('.wb-cl__card', item), pill = $('.wb-cl__pill', item), p = $('p', card);
      var a = item.getBoundingClientRect();
      if (toOpen) { card.hidden = false; item.classList.add('open'); }
      else { if (p) p.classList.remove('in'); item.classList.remove('open'); card.hidden = true; }
      pill.setAttribute('aria-expanded', String(toOpen));
      if (phone.matches || reduce.matches || !item.animate) { if (toOpen && p) p.classList.add('in'); return; }
      var b = item.getBoundingClientRect();
      item.animate([{ width: a.width + 'px', height: a.height + 'px' }, { width: b.width + 'px', height: b.height + 'px' }],
        { duration: 460, easing: EZ });
      if (toOpen && p) setTimeout(function () { p.classList.add('in'); }, 200);
    }
    /* Phones follow Apple: the open card sits over the picture, the other features wait as blank glass cards
       peeking at the edges, and swiping the row (or the edge arrows) opens the next one. */
    var list = $('[data-wb-cl-list]', sec), syncing = 0;
    function centre(it, smooth) {
      if (!list || !it) return;
      syncing = Date.now();
      list.scrollTo({ left: it.offsetLeft - (list.clientWidth - it.offsetWidth) / 2, behavior: smooth && !reduce.matches ? 'smooth' : 'auto' });
    }
    function open(i) {
      if (i === cur) return;
      var prev = items[cur - 1], next = items[i - 1];
      if (prev) morph(prev, false);
      if (next) morph(next, true);
      cur = i; layer(i); sec.classList.add('active');
      if (phone.matches && next) requestAnimationFrame(function () { centre(next, true); });
    }
    function close() {
      var prev = items[cur - 1];
      if (prev) morph(prev, false);
      cur = 0; layer(0); sec.classList.remove('active');
      if (phone.matches && list) { syncing = Date.now(); list.scrollTo({ left: 0, behavior: 'auto' }); }
    }
    if (list) {
      var st = 0;
      list.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          if (!phone.matches || !cur || Date.now() - syncing < 700) return;
          var mid = list.scrollLeft + list.clientWidth / 2, best = cur, bd = Infinity;
          items.forEach(function (it, n) { var d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = n + 1; } });
          if (best !== cur) open(best);
        }, 140);
      }, { passive: true });
    }
    items.forEach(function (it, n) {
      $('.wb-cl__pill', it).addEventListener('click', function () { if (cur === n + 1 && phone.matches) close(); else open(n + 1); });
    });
    var nx = $('[data-wb-cl-next]', sec), pv = $('[data-wb-cl-prev]', sec), cl = $('[data-wb-cl-close]', sec);
    if (nx) nx.addEventListener('click', function () { open(cur >= items.length ? 1 : cur + 1); });
    if (pv) pv.addEventListener('click', function () { open(cur <= 1 ? items.length : cur - 1); });
    if (cl) cl.addEventListener('click', close);
    sec.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cur) close(); });
  })();

  /* ---------- 4. the felt: Hear the difference ----------
     Ported from the Panel Collective prototype (HearTheDifference.astro). One analyser, both takes feeding
     it, and a canvas where the voice level sets how much sound leaves the centre. With the panels it leaves
     in even rings and the edge absorbs it; without, it scatters and the edges give most of it back. */
  (function () {
    var sec = $('[data-wb-felt]'); if (!sec) return;
    var bg = $('[data-wb-felt-bg]', sec);
    /* the felt drifts a little slower than the page */
    if (bg && !reduce.matches) {
      var tick = false;
      var frame = function () {
        tick = false;
        var r = sec.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        var k = 1 - (r.top + r.height / 2) / (innerHeight / 2 + r.height / 2);
        bg.style.transform = 'translate3d(0,' + (k * 3).toFixed(2) + '%,0)';
      };
      addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(frame); } }, { passive: true });
      frame();
    }

    var canvas = $('[data-wb-viz]', sec), playBtn = $('[data-wb-play]', sec), sw = $('[data-wb-sw]', sec);
    var stopBtn = $('[data-wb-stop]', sec), progWrap = $('[data-wb-progwrap]', sec), progress = $('[data-wb-progress]', sec);
    var audio = { without: $('[data-a="without"]', sec), with: $('[data-a="with"]', sec) };
    if (!canvas || !playBtn || !audio.without || !audio.with) { if (playBtn) playBtn.hidden = true; return; }
    var g = canvas.getContext('2d');
    var light = sec.getAttribute('data-felt') === 'white';
    var FRESH = light ? '138, 85, 48' : '242, 183, 122', OLD = light ? '36, 26, 22' : '244, 241, 236';

    var actx = null, analyser = null, wave = null, failed = false;
    function graph() {
      if (analyser || failed) return;
      try {
        var AC = window.AudioContext || window.webkitAudioContext; if (!AC) throw 0;
        actx = new AC(); analyser = actx.createAnalyser(); analyser.fftSize = 512; analyser.smoothingTimeConstant = 0.3;
        [audio.without, audio.with].forEach(function (a) { actx.createMediaElementSource(a).connect(analyser); });
        analyser.connect(actx.destination); wave = new Uint8Array(analyser.fftSize);
      } catch (e) { failed = true; analyser = null; }
    }
    function level() {
      if (!analyser) return 0.12 + 0.08 * Math.sin(performance.now() / 700);
      analyser.getByteTimeDomainData(wave);
      var s = 0; for (var i = 0; i < wave.length; i++) { var v = (wave[i] - 128) / 128; s += v * v; }
      return Math.min(1, Math.sqrt(s / wave.length) * 4);
    }
    var W = 0, H = 0, dpr = 1, raf = 0, calm = false, MAX = 700, RING = 22, rays = [], pulse = 0, turn = 0;
    function size() {
      var r = sec.getBoundingClientRect();
      W = Math.max(1, Math.round(r.width)); H = Math.max(1, Math.round(r.height));
      dpr = Math.min(2, window.devicePixelRatio || 1); canvas.width = W * dpr; canvas.height = H * dpr; g.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spawn(a, sp) { rays.push({ x: W / 2, y: H / 2, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, e: 1, age: 0, b: 0 }); }
    function step() {
      var lv = level();
      if (calm) {
        pulse += lv * lv * 0.55 + 0.012;
        if (pulse >= 1 && rays.length + RING <= MAX) {
          pulse = 0; turn += Math.PI / RING / 2;
          var sp = 0.8 * Math.max(W, H) / 110;
          for (var i = 0; i < RING; i++) spawn(turn + (i / RING) * Math.PI * 2, sp);
        }
      } else {
        var n = Math.round(lv * lv * 16) + (Math.random() < 0.15 ? 1 : 0);
        for (var j = 0; j < n && rays.length < MAX; j++) spawn(Math.random() * Math.PI * 2, (0.5 + Math.random() * 0.5) * Math.max(W, H) / 110);
      }
      for (var k = rays.length - 1; k >= 0; k--) {
        var r = rays[k]; r.x += r.vx; r.y += r.vy; r.age++;
        var hit = false;
        if (r.x < 0) { r.x = 0; r.vx = -r.vx; hit = true; } else if (r.x > W) { r.x = W; r.vx = -r.vx; hit = true; }
        if (r.y < 0) { r.y = 0; r.vy = -r.vy; hit = true; } else if (r.y > H) { r.y = H; r.vy = -r.vy; hit = true; }
        if (hit) { if (calm) r.e = 0; else { r.b++; r.e *= 0.82; r.vx += (Math.random() - 0.5) * 0.6; r.vy += (Math.random() - 0.5) * 0.6; } }
        r.e *= calm ? 0.992 : 0.996;
        if (r.e < 0.03) rays.splice(k, 1);
      }
    }
    function draw() {
      raf = 0; if (canvas.hidden) return;
      step(); g.clearRect(0, 0, W, H);
      var rad = W < 768 ? 2.2 : 3;
      for (var i = 0; i < rays.length; i++) {
        var r = rays[i], fresh = r.age < 8 && r.b === 0;
        g.fillStyle = 'rgba(' + (fresh ? FRESH : OLD) + ',' + ((fresh ? 0.95 : 0.8) * r.e) + ')';
        g.beginPath(); g.arc(r.x, r.y, rad, 0, Math.PI * 2); g.fill();
      }
      raf = requestAnimationFrame(draw);
    }
    function viz(on) {
      canvas.hidden = !on;
      if (!on) { if (raf) cancelAnimationFrame(raf); raf = 0; rays.length = 0; return; }
      size(); if (!raf) raf = requestAnimationFrame(draw);
    }
    var playing = false, current = 'without';
    function setCalm(c) {
      calm = c; sec.setAttribute('data-calm', c ? 'with' : 'without');
      $$('[data-set]', sw).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-set') === (c ? 'with' : 'without'))); });
    }
    function seekPlay(a, t) {
      var go = function () { try { a.currentTime = t; } catch (e) {} a.play().catch(function () {}); };
      if (a.readyState >= 1) go(); else { a.addEventListener('loadedmetadata', go, { once: true }); a.load(); }
    }
    function stop() {
      if (!playing) return; playing = false; sec.classList.remove('playing');
      [audio.without, audio.with].forEach(function (a) { a.pause(); try { a.currentTime = 0; } catch (e) {} });
      viz(false); sw.hidden = true; stopBtn.hidden = true; progWrap.hidden = true; playBtn.hidden = false;
      progress.style.setProperty('--p', '0');
    }
    function play() {
      if (playing) return; playing = true; sec.classList.add('playing'); graph();
      if (actx && actx.state === 'suspended') actx.resume().catch(function () {});
      playBtn.hidden = true; sw.hidden = false; stopBtn.hidden = false; progWrap.hidden = false;
      setCalm(current === 'with'); viz(true); seekPlay(audio[current], audio[current].currentTime || 0);
    }
    /* the switch starts the other take at the same moment, so the sentence carries on mid-word */
    function select(which) {
      if (which === current) return;
      var from = audio[current], to = audio[which], t = from.currentTime || 0;
      from.pause(); current = which; setCalm(which === 'with');
      if (playing) seekPlay(to, t);
    }
    playBtn.addEventListener('click', play);
    stopBtn.addEventListener('click', stop);
    $('[data-wb-toggle]', sec).addEventListener('click', function () { select(current === 'with' ? 'without' : 'with'); });
    $$('[data-set]', sw).forEach(function (b) { b.addEventListener('click', function () { select(b.getAttribute('data-set')); }); });
    progWrap.addEventListener('click', function (e) {
      if (!playing) return;
      var r = progWrap.getBoundingClientRect(), f = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      var a = audio[current]; if (!a.duration) return;
      var t = f * a.duration;
      [audio.without, audio.with].forEach(function (x) { if (x !== a) { try { x.currentTime = t; } catch (err) {} } });
      seekPlay(a, t); progress.style.setProperty('--p', String(f));
    });
    ['without', 'with'].forEach(function (k) {
      var a = audio[k];
      a.addEventListener('timeupdate', function () { if (k === current && a.duration) progress.style.setProperty('--p', String(a.currentTime / a.duration)); });
      a.addEventListener('ended', stop);
      a.addEventListener('error', function () { stop(); playBtn.hidden = true; });
    });
    addEventListener('resize', function () { if (!canvas.hidden) size(); });
    /* a voice must never carry on under the rest of the page */
    if (hasIO) new IntersectionObserver(function (es) { es.forEach(function (en) { if (!en.isIntersecting) stop(); }); }, { threshold: 0.05 }).observe(sec);
    setCalm(false);
  })();

  /* ---------- the acoustic gallery arrows ---------- */
  (function () {
    var gal = $('[data-wb-gal]'); if (!gal) return;
    var track = $('[data-wb-gal-track]', gal);
    function by(dir) {
      var c = $('.wb-gal__card', track); if (!c) return;
      track.scrollBy({ left: dir * (c.getBoundingClientRect().width + 20), behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    var p = $('[data-wb-gal-prev]', gal), n = $('[data-wb-gal-next]', gal);
    if (p) p.addEventListener('click', function () { by(-1); });
    if (n) n.addEventListener('click', function () { by(1); });
    /* the arrows dim at the ends of the row, as Apple's do */
    function upd() {
      if (p) p.disabled = track.scrollLeft <= 2;
      if (n) n.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    track.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
  })();

  /* ---------- 5. installation: the film plays only while you can see it, and drives its steps ---------- */
  (function () {
    var fig = $('[data-wb-film]'); if (!fig) return;
    var v = $('video', fig), pp = $('[data-wb-film-pp]', fig), user = false;
    var steps = $$('[data-wb-steps] .wb-istep');
    function load() { if (!v.getAttribute('src') && v.dataset.src) { v.src = v.dataset.src; v.preload = 'auto'; } }
    function sync(vis) {
      if (user || reduce.matches || !vis) { v.pause(); fig.classList.add('paused'); return; }
      load();
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      fig.classList.remove('paused');
    }
    if (hasIO) new IntersectionObserver(function (es) { sync(es[0].isIntersecting); }, { threshold: 0.4 }).observe(fig);
    if (reduce.matches) fig.classList.add('paused');
    pp.addEventListener('click', function () {
      if (v.paused) { user = false; load(); v.play().catch(function () {}); fig.classList.remove('paused'); pp.setAttribute('aria-label', 'Pause the film'); }
      else { user = true; v.pause(); fig.classList.add('paused'); pp.setAttribute('aria-label', 'Play the film'); }
    });
    /* the step that matches the film lights up, and its rule fills as that step plays.
       ONE loop only: 'play' fires every time the film comes back on screen, and starting a fresh loop on
       each of those let them pile up the longer the page stayed open. */
    var raf = 0;
    function paint() {
      var t = v.currentTime || 0;
      steps.forEach(function (s) {
        var a = +s.dataset.at, b = +s.dataset.to, on = t >= a && t < b;
        s.classList.toggle('on', on);
        s.style.setProperty('--p', on ? Math.min(1, (t - a) / (b - a)).toFixed(3) : 0);
      });
    }
    function tick() { paint(); raf = v.paused || document.hidden ? 0 : requestAnimationFrame(tick); }
    function run() { if (!raf) raf = requestAnimationFrame(tick); }
    v.addEventListener('play', run);
    v.addEventListener('pause', function () { cancelAnimationFrame(raf); raf = 0; paint(); });
    v.addEventListener('seeked', paint);
    /* a hidden tab pauses the film outright, so it never has to catch up when you come back */
    var wasOn = false;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { wasOn = !v.paused; if (wasOn) v.pause(); }
      else if (wasOn) { v.play().catch(function () {}); }
    });
    steps.forEach(function (s) {
      s.addEventListener('click', function () {
        load(); user = false;
        try { v.currentTime = +s.dataset.at + 0.05; } catch (e) {}
        v.play().catch(function () {}); fig.classList.remove('paused');
      });
    });
  })();

  /* ---------- the full install video, in a modal rather than off to YouTube ---------- */
  (function () {
    var btn = $('[data-wb-yt]'); if (!btn) return;
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-wb-yt'), prev = document.documentElement.style.overflow;
      var m = document.createElement('div');
      m.className = 'wb-modal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', 'Install video');
      m.innerHTML = '<button type="button" class="wb-icbtn wb-modal__x" aria-label="Close"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<div class="wb-modal__box"><iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1" title="Installing Acupanel" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe></div>';
      root.appendChild(m);
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { m.classList.add('on'); });
      var x = m.querySelector('.wb-modal__x'); x.focus();
      function shut() {
        m.classList.remove('on'); document.documentElement.style.overflow = prev;
        document.removeEventListener('keydown', key);
        setTimeout(function () { m.remove(); btn.focus(); }, 300);
      }
      function key(e) { if (e.key === 'Escape') shut(); }
      x.addEventListener('click', shut);
      m.addEventListener('click', function (e) { if (e.target === m) shut(); });
      document.addEventListener('keydown', key);
    });
  })();

  /* ---------- the close finds the buy box ---------- */
  $$('[data-wb-jump]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = document.querySelector('[id^="pd-buy-"]') || document.querySelector('[data-pd-buy]');
      if (t) t.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'center' });
    });
  });
})();
